/**
 * Browser stand-in for the node `process` global, injected via ProvidePlugin.
 *
 * webpack 4 shimmed `process` into every browser bundle automatically
 * (node-libs-browser); webpack 5 dropped that, and dependencies that touch the
 * bare identifier at module init throw ReferenceError without it — remeasure's
 * `!!(process && process.env && ...)` took down every chunk that contained it
 * in builds 879/881. This mirrors the parts of process/browser.js our bundles
 * actually reach. `process.env.NODE_ENV` itself is inlined at build time by
 * webpack's DefinePlugin (optimization.nodeEnv), so env stays empty here, same
 * as the old webpack 4 mock.
 */

var process = module.exports = {};

process.env = {};
process.browser = true;
process.title = 'browser';
process.argv = [];
process.version = '';
process.versions = {};
process.platform = 'browser';

process.nextTick = function (fn) {
	var args = Array.prototype.slice.call(arguments, 1);
	setTimeout(function () {
		fn.apply(null, args);
	}, 0);
};

function noop() {}

//- event-emitter surface some libraries sniff before subscribing
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function () { return []; };

process.cwd = function () { return '/'; };
process.chdir = function () {
	throw new Error('process.chdir is not supported in the browser');
};
process.umask = function () { return 0; };
